import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import PaymentList from './List';
import { Box, Button, Card, Tab, Tabs } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { ArrowBack } from '@mui/icons-material';
import AddEditPayment from './AddEditPayment';

const BookingPayment = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'booking-payment'
        });
    }, []);
    const navigate = useNavigate();
      const [tabValue, setTabValue] = useState('0');
      const handleChange = (event, newValue) => {
          setTabValue(newValue);
    }
    return (
      <>
        <PageHeaderLayout headerTitle={'Manage Booking Payment'}>
            <Button size='small' variant='contained' onClick={() => navigate(-1)} endIcon={<ArrowBack sx={{fontSize:'.85rem'}}/>} sx={{ textTransform:'capitalize' }}>
                Back
            </Button>
        </PageHeaderLayout>
        <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                    sx={{ p: 0, minHeight: '40px' }}
                    variant="scrollable"
                    scrollButtons="auto"
                >

                    <Tab value="0" label="New Payment" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
                    <Tab value="1" label="Payment List" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                </Tabs>
            </Box>
        </Card>
        {tabValue == '0' && <AddEditPayment />}
        {tabValue == '1' && <PaymentList />}
        
    </>
  )
}

export default BookingPayment
